module.exports = __webpack_public_path__ + "img/IsDasNormal.5ceeddd5.jpg";